import './customer-service-dropdown.scss';
import React, { useEffect, useMemo, useState } from 'react';
import { ServiceDto } from '../../../dtos/customer.dto';
import GenericModal from '../../shared/generic-modal/generic-modal';
import FormField from '../../shared/edit-row-modal/form-field/form-field';
import {
    DUPLICATE_SERVICE_NAME,
    ILLEGAL_CHARACTERS_MESSAGE,
    isValueDuplicate,
    validateConnectionName
} from '../../../utils/validationUtils';
import { CustomInput } from '../../shared/custom-input/custom-input';
import usePromiseFeedback from '../../shared/promise-feedback/usePromiseFeedback';
import { useStores } from '../../store';
import { EventType } from '../../../dtos/analytics.dto';

export const EditConnectionNameModal: React.FC<{
    connection: ServiceDto,
    open: boolean,
    close: () => void
}> = ({
          connection,
          open,
          close
      }) => {

    const [newConnectionName, setNewConnectionName] = useState(connection.serviceName || connection.adiCircuitId);
    const [promiseFeedbackFactory, promiseContextHolder] = usePromiseFeedback();
    const { customerStore } = useStores();

    useEffect(() => {
        if (open) {
            setNewConnectionName(connection.serviceName || connection.adiCircuitId);
        }
    }, [open, connection.serviceName, connection.adiCircuitId]);

    const isDirty = newConnectionName !== (connection.serviceName || connection.adiCircuitId);

    const save = () => {
        close();
        promiseFeedbackFactory({
            promise: customerStore.setConnectionName(connection.serviceId, newConnectionName || undefined),
            successCallback: () => {
                customerStore.sendGeneralEvent(EventType.LinkClicked, { button: 'connection_name_change', connectionName: newConnectionName });
            },
            notifObj: { show: true, notificationMsg: 'Connection details saved' }
        });
    };

    const nameError = useMemo(() => {
        const previousConnectionName = connection.serviceName || connection.adiCircuitId;
        if (!newConnectionName) return '';
        if (newConnectionName.trim() === '') return ILLEGAL_CHARACTERS_MESSAGE;


        const listToCompare = customerStore.selectedCustomer?.services?.filter(_ => _.serviceId !== connection.serviceId);
        if (isValueDuplicate(newConnectionName, previousConnectionName, listToCompare, 'serviceName') ||
            isValueDuplicate(newConnectionName, previousConnectionName, listToCompare, 'adiCircuitId')) return DUPLICATE_SERVICE_NAME;
        
        return !validateConnectionName(newConnectionName) ? '' : ILLEGAL_CHARACTERS_MESSAGE;
    }, [newConnectionName]);

    const actionButton: any[] = useMemo(() => [
        {
            text: 'Cancel',
            onClick: close,
            className: 'secondary-btn'
        },
        {
            text: 'Save',
            onClick: save,
            className: 'primary-btn',
            disabled: !isDirty || !!nameError
        }
    ], [close, save, nameError, isDirty]);

    const body =
        <FormField label={'Connection Name'} errorMessage={nameError}>
            <CustomInput inputType="INPUT"
                         type="text"
                         hideWarnMessage={!!nameError}
                         value={newConnectionName}
                         onChange={(e) => setNewConnectionName(e.target.value)}
                         maxLength={25}/>
        </FormField>;

    return <><GenericModal wrapClassName={'edit-connection-modal'}
                           title={'Edit Connection Name'}
                           body={body}
                           actionButtons={actionButton}
                           open={open}
                           closable={false}
    />
        {promiseContextHolder}
    </>;
};